import { useCallback, useState } from 'react';
import { countingAPI } from '../../API/countingAPI';

const useCountings = () => {
  const [countings, setCountings] = useState([]);
  const [aggregates, setAggregates] = useState([]);
  const [dailySummary, setDailySummary] = useState([]);
  const [totalDailyCount, setTotalDailyCount] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadByClient = useCallback(async (clientId, page = 1, itemsPerPage = 50) => {
    setLoading(true);
    setError(null);
    try {
      const data = await countingAPI.listByClient(clientId, page, itemsPerPage);
      if (data && !data.error) {
        setCountings(data.value?.items || []);
      } else {
        setError('Failed to load countings');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const loadAggregates = useCallback(async (clientId, startDate, endDate, timeUnit = 'HOUR', storeId = null) => {
    setLoading(true);
    setError(null);
    try {
      const data = await countingAPI.getAggregates(clientId, startDate, endDate, timeUnit, storeId);
      if (data && !data.error) {
        setAggregates(data.value || []);
      } else {
        setError('Failed to load aggregates');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const loadDailySummary = useCallback(async (clientId, startDate, endDate, storeId = null, storeIds = null, search = null, cities = null, page = null, itemsPerPage = null) => {
    setLoading(true);
    setError(null);
    try {
      const data = await countingAPI.getDailySummary(clientId, startDate, endDate, storeId, storeIds, search, cities, page, itemsPerPage);
      if (data && !data.error) {
        const items = data.value?.items ?? data.value?.Items ?? data.value ?? (Array.isArray(data) ? data : []);
        const count = data.value?.totalCount ?? data.value?.TotalCount ?? (Array.isArray(items) ? items.length : 0);
        setDailySummary(Array.isArray(items) ? items : []);
        setTotalDailyCount(count);
      } else {
        setError('Failed to load daily summary');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    countings,
    aggregates,
    dailySummary,
    totalDailyCount,
    isLoading,
    error,
    loadByClient,
    loadAggregates,
    loadDailySummary,
  };
};

export default useCountings;
